"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var useEfficientDragLayer_1 = __importDefault(require("./useEfficientDragLayer"));
var defaultProjection = function (monitor) { return monitor.getDifferenceFromInitialOffset(); };
var DragAround = function (_a) {
    var children = _a.children, innerRef = _a.innerRef, dragging = _a.dragging, preTransform = _a.preTransform, postTransform = _a.postTransform, animation = _a.animation, _b = _a.projection, projection = _b === void 0 ? defaultProjection : _b, props = __rest(_a, ["children", "innerRef", "dragging", "preTransform", "postTransform", "animation", "projection"]);
    var transition = (0, react_2.useMemo)(function () {
        var _a, _b, _c, _d;
        var transitionProperty = (_b = (_a = animation === null || animation === void 0 ? void 0 : animation.properties) === null || _a === void 0 ? void 0 : _a.join(', ')) !== null && _b !== void 0 ? _b : 'transform';
        return (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      transition-property: ", ";\n      will-change: ", ";\n      transition-duration: ", "s;\n      transition-timing-function: ", ";\n    "], ["\n      transition-property: ", ";\n      will-change: ", ";\n      transition-duration: ", "s;\n      transition-timing-function: ", ";\n    "])), transitionProperty, transitionProperty, (_c = animation === null || animation === void 0 ? void 0 : animation.seconds) !== null && _c !== void 0 ? _c : 0.2, (_d = animation === null || animation === void 0 ? void 0 : animation.timingFunction) !== null && _d !== void 0 ? _d : 'ease-in-out');
    }, [animation]);
    var offset = (0, useEfficientDragLayer_1.default)(projection);
    var transform = (0, react_2.useMemo)(function () {
        var transformations = [];
        if (preTransform)
            transformations.push(preTransform);
        if (dragging && offset)
            transformations.push("translate3d(".concat(Math.round(offset.x), "px, ").concat(Math.round(offset.y), "px, 0)"));
        if (postTransform)
            transformations.push(postTransform);
        if (dragging && offset)
            transformations.push('!important');
        return transformations.length > 0 ? (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["transform: ", ";"], ["transform: ", ";"])), transformations.join(' ')) : undefined;
    }, [dragging, offset, preTransform, postTransform]);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ ref: innerRef, css: [transition, transform, dragging && draggingStyle] }, props, { children: children })));
};
var draggingStyle = (0, react_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  transition: none;\n  z-index: 1000 !important;\n  pointer-events: none;\n"], ["\n  transition: none;\n  z-index: 1000 !important;\n  pointer-events: none;\n"])));
exports.default = (0, react_2.forwardRef)(function (props, ref) { return (0, jsx_runtime_1.jsx)(DragAround, __assign({ innerRef: ref }, props)); });
var templateObject_1, templateObject_2, templateObject_3;
